export const RoleGetSchema = {
    id: 'id',
    pages: {
        general: {
            pageId: 'general',
            description: 'description',
            rules: 'rules',
            rulesSchema: {
                type: 'type',
                typeValues: {
                    ALLOW: 'ALLOW',
                    BLOCK: 'BLOCK'
                },
                actions: 'actions',
                actionsValues: {
                    READ: 'READ',
                    MODIFY: 'MODIFY',
                    CREATE: 'CREATE',
                    DELETE: 'DELETE'
                },
                subject: 'subject',
                subjectSchema: {
                    target: 'target',
                    targetValues: {
                        ANY: 'ANY',
                        USER: 'USER',
                        CPSMPPLAN: 'CPSMPPLAN',
                        COMMUNITY: 'COMMUNITY',
                        CPSMPGATEWAY: 'CPSMPGATEWAY',
                        ROLE: 'ROLE',
                        POLICY: 'POLICY',
                        CUSTOM_IMAGE: 'CUSTOM_IMAGE',
                        FIRMWARE: 'FIRMWARE',
                        PORTAL_SETTINGS: 'PORTAL_SETTINGS'
                    },
                    condition: 'condition'
                },
            }
        },
        advanced: {
            pageId: 'advanced',
            isAccessSMPWebUI: 'isAccessSMPWebUI',
            isEnableLostPasswordRecovery: 'isEnableLostPasswordRecovery',
            isAccessAPI: 'isAccessAPI',
            isViewLogs: 'isViewLogs',
            isSendEmail: 'isSendEmail',
            ranges: 'ranges',
            rangesSchema: {
                startIp: 'startIp',
                endIp: 'endIp'
            }
        }
    }
}

export const RoleGetListSchema = {
    name: 'name',
    description: 'description',
    predefined: 'predefined'
}

export const RoleCreateSchema = {
    name: 'name',
    description: 'description'
}

export const RoleRuleSchema = {
    type: 'type',
    typeValues: {
        ALLOW: 'ALLOW',
        BLOCK: 'BLOCK'
    },
    actions: 'actions',
    actionsValues: {
        READ: 'READ',
        MODIFY: 'MODIFY',
        CREATE: 'CREATE',
        DELETE: 'DELETE'
    },
    subject: 'subject',
    subjectSchema: {
        target: 'target',
        targetValues: {
            ANY: 'ANY',
            USER: 'USER',
            CPSMPPLAN: 'CPSMPPLAN',
            COMMUNITY: 'COMMUNITY',
            CPSMPGATEWAY: 'CPSMPGATEWAY',
            ROLE: 'ROLE',
            POLICY: 'POLICY',
            CUSTOM_IMAGE: 'CUSTOM_IMAGE',
            FIRMWARE: 'FIRMWARE',
            PORTAL_SETTINGS: 'PORTAL_SETTINGS'
        },
        condition: 'condition'
    }
}